import React from 'react';
import { motion } from 'framer-motion';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { useResponseStore } from '../../../store/responseStore';
import { Button } from '../../../components/surveys/surveys/client/Button';

export const Services = (props) => {

    const { data, action } = props;
    const classes = useStyles();
	const setService = useResponseStore(state => state.setService);

	const handleClick = (service) => {
		action();
		setService(service);
	}

    return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1}}
			transition={{ duration: 1.5 }}
			style={{ width: '100%' }}
		>
			<Grid container justifyContent='center' alignItems='center'>
				<Grid item xs={ 12 } sm={ 12 } md={ 12 } lg={ 12 } xl={ 12 }>
					<h1 className={ classes.title }>{ convertirLetraMayus(data?.introduccion_servicios) }</h1>	
				</Grid>
			</Grid>

			<Grid container gap={2} justifyContent='center' alignItems='center' className={ classes.containetButtons }>
				{
					data?.servicios?.map(d => (
						<Button
							key={ d?.servicio }
							title={ convertirLetraMayus(d?.servicio) }
							breakPoints={ [10, 7, 4, 3] }
							action={ () => handleClick(d?.servicio) }
						/>
					))
				}
			</Grid>
		</motion.div>
	)
}

const useStyles = makeStyles({
	title: {
		color: '#fff',
		textAlign: 'center',
		margin: '30px',
		letterSpacing: 1,
		fontSize: 'clamp(1.2rem, 4vw, 2.5rem)'
	},
	containetButtons: {
		padding: '10px 0px',
		maxHeight: '50vh',
		
		'@media all and (orientation: landscape)': {
			maxHeight: window.innerHeight /1.5,
			overflow: 'scroll'
		},

		overflow: 'scroll',
	}
});